import api from '../../../services/Api';
import { IAuditoriaBancariaResultado } from '../interfaces/IAuditoriaBancaria';

export const AuditoriaBancariaService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaBancariaResultado> {
    const response = await api.get<IAuditoriaBancariaResultado>('auditoria-bancaria/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        faturamentoPeriodo: 0,
        penalidadePrevisivelTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        contas: [],
      }
    );
  },
};
